import { Grid } from '@mui/material';
import { get } from 'lodash';
import { default as React } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { CasesParams } from 'utils/useCasesParams/types';
import { ChannelsController } from '../../ChannelsController';
import { QcAnalysisFormValues } from './types';

export interface AdditionalParametersStepProps {
  casesParams: CasesParams;
  methods: UseFormReturn<QcAnalysisFormValues, any>;
  checkValidationAndSetIsStepFailed: () => void;
}

export const AdditionalParametersStep: React.FC<AdditionalParametersStepProps> = ({
  casesParams,
  methods,
  checkValidationAndSetIsStepFailed,
}) => {
  const {
    watch,
    formState: { errors },
  } = methods;

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <ChannelsController
          name="configParams.markers"
          error={Boolean(get(errors, 'configParams.markers'))}
          helperText={get(errors, 'configParams.markers')?.message}
          methods={methods}
          additionalOnChange={() => {
            checkValidationAndSetIsStepFailed();
          }}
          casesParams={casesParams}
        ></ChannelsController>
      </Grid>
    </Grid>
  );
};
